@if (basdata !== null) {
  <rask-toggle-panel label="{{ 'JUSTERA_LEVERANSPLAN_PRODUKTIONSOMRADE_URVAL' | translate }}" [defaultExpanded]="true"
    >
    <rask-jlp-saved-searches
      [name]="name"
      [WIK]="WIKSparade"
      (selectedFilter)="setSokning($event)"
      (triggerSave)="saveSearchParams()"
      [triggerSparaFilter]="triggerSparaFilter">
    </rask-jlp-saved-searches>
    @if (model) {
      <form [formGroup]="produktionsomradenForm">
        <div class="row">
          <!-- MO/RO/PO -->
          <div class="col-4">
            @if (basdata.marknadsomraden.length > 0) {
              <rask-tree-selector
                aid="inputOmraden"
                id="selectArea"
                class="form-group w-100"
                [label]="'JUSTERA_LEVERANSPLAN_AREASELECTOR' | translate"
                [items]="basdata.omraden"
                [required]="false"
                [manualItemSync]="true"
                [syncOnClear]="true"
                formControlName="omraden">
              </rask-tree-selector>
            }
          </div>
          <div class="col-4">
            <!-- Kund -->
            <rask-multi-selector
              aid="inputKunder"
              class="col-12"
              label="{{'JUSTERA_LEVERANSPLAN_KUNDNAMN' | translate}}"
              bindLabel="namn"
              formControlName="kunder"
              typeToSearchText="Ange minst tre tecken"
              loadingText="Laddar..."
              notFoundText="Ingen träff"
              [minTermLength]="3"
              [typeaheadFn]="searchForCustomer"
              [selected]="produktionsomradenForm.value.kunder">
            </rask-multi-selector>
          </div>
          <!-- Mottagningsplats -->
          <div class="col-4">
            <rask-multi-selector
              aid="inputMottagningsplatser"
              class="col-12"
              label="{{'JUSTERA_LEVERANSPLAN_LAGERPLATS' | translate}}"
              bindLabel="namn"
              formControlName="mottagningsplatser"
              typeToSearchText="Ange minst tre tecken"
              loadingText="Laddar..."
              notFoundText="Ingen träff"
              [minTermLength]="3"
              [typeaheadFn]="searchForMottagningsplatsTypeAhead"
              [selected]="produktionsomradenForm.value.mottagningsplatser">
            </rask-multi-selector>
          </div>
        </div>
        <div class="row">
          <!-- Handelssortiment -->
          <div class="col-4">
            @if (basdata.handelssortimentsgrupper.length > 0) {
              <rask-tree-selector ignore-readonly
                aid="inputHandelssortimentsgrupper"
                id="selectProduktgrupp"
                class="form-group w-100"
                [label]="'JUSTERA_LEVERANSPLAN_HANDELSSORTIMENT' | translate"
                [items]="basdata.handelssortiment"
                [required]="false"
                [manualItemSync]="true"
                [syncOnClear]="true"
                formControlName="handelssortimentsgrupper">
              </rask-tree-selector>
            }
          </div>
          <!-- Period fr.o.m -->
          <div class="col-2">
            <rask-datepicker
              aid="inputPeriodFrom"
              formControlName="periodFrom"
              class="w-100"
              [label]="'JUSTERA_LEVERANSPLAN_PERIODFROM' | translate"
              [minDate]=""
              [onlyMonths]="true"
              [required]="true"
              [rule]="validationContext.current.periodFrom">
            </rask-datepicker>
          </div>
          <!-- Period t.o.m -->
          <div class="col-2">
            <rask-datepicker
              aid="inputPeriodTom"
              formControlName="periodTom"
              class="w-100"
              [label]="'JUSTERA_LEVERANSPLAN_PERIODTOM' | translate"
              [minDate]=""
              [onlyMonths]="true"
              [required]="true"
              [minDate]="produktionsomradenForm.value.periodFrom"
              [rule]="validationContext.current.periodTom">
            </rask-datepicker>
          </div>
        </div>
        <div footer class="d-flex mt-3">
          <rask-button class="mt-0" aid="buttonSok" color="secondary" (click)="search()">
          {{ 'DEFAULT_BUTTON_LABEL_VISA' | translate }}</rask-button>
          <rask-button class="mt-0" aid="buttonRensa" color="secondary" negative (click)="reset()">
          {{ 'DEFAULT_BUTTON_LABEL_RENSA' | translate }}</rask-button>
        </div>
      </form>
    }
  </rask-toggle-panel>
}

<!-- eslint-disable-next-line @angular-eslint/template/eqeqeq-->
@if (showResults === true && noOrderrows !== true && currentData != null) {
  <rask-jlp-produktionsomraden-result
    class="w-100"
    [canEdit]="canEdit"
    [settings]="settings"
    [period]="period"
    [data]="currentData"
    [senastAktivaProduktionsomraden]="senastAktivaProduktionsomraden">
  </rask-jlp-produktionsomraden-result>
}
@if (noOrderrows === true) {
  <span translate="JUSTERA_LEVERANSPLAN_EMPTY_RESULT"></span>
}